<template>
  <modal :center="false" :show="visible" modalClasses="modal-lg">
    <h3 class="text-center">
      Hủy Tem
    </h3>
    <block ref="bmdal">
      <ValidationObserver ref="csInfo" v-slot="{ handleSubmit }">
        <form role="form" @submit.prevent="handleSubmit">
          <b-row>
            <b-col cols="12">
              <base-input
                label="Mã tem"
                readonly="true"
                v-model="info.code"
              ></base-input>
              <b-textarea
                v-model="info.note"
                placeholder="Lý do hủy tem"
                rows="3"
              ></b-textarea>
            </b-col>
          </b-row>
        </form>
        <hr />
        <button type="button" @click="handleClose" class="btn btn-secondary">
          Đóng (Esc)
        </button>
        <button type="button" @click="doDestroy()" class="btn btn-danger">
          Hủy tem
        </button>
      </ValidationObserver>
    </block>
    <event @doCancel="handleClose"></event>
  </modal>
</template>
<script>
import { temService } from "@/_services";
export default {
  props: {},
  data() {
    return {
      visible: false,
      info: {},
      ownInfo: {}
    };
  },
  methods: {
    doDestroy: function() {
      var self = this;
      if (!this.visible) return;
      this.$refs.csInfo.validate().then(success => {
        if (!success) return;
        this.$swal({
          title: "Bạn có chắc thực hiện thao tác này?",
          text: "Bạn sẽ không thể hoàn nguyên điều này!!",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "OK",
          cancelButtonText: "Không",
          reverseButtons: true
        }).then(function(result) {
          if (result.value) {
            self.$refs.bmdal.block();
            self.isPending = true;
            if (self.info.id) {
              temService
                .destroy(self.info.id, self.info.note)
                .then(res => {
                  self.ownInfo.note = self.info.note;
                  self.$alertify.success(res.message, {
                    duration: 4000
                  });
                })
                .finally(() => {
                  self.visible = false;
                  self.$refs.bmdal.unBlock();
                });
            }
          }
        });
      });
    },
    setData(info) {
      this.ownInfo = info;
      this.info = Object.assign({}, info);
      delete this.info.rule;
    },
    handleClose() {
      this.visible = false;
    }
  }
};
</script>
